/*
 File: matchmedia-checker.js
 Author: D McCleod
 Created: 2/22/2017
 Modified:
 Description: return boolean when viewport is with in specified breakpoints using Window.matchMedia();
 */

// TODO: add queries for retina dislpay

const queryList = {
    mq1: '(min-width: 320px) and (max-width: 767px)',
    mq2: '(min-width: 768px) and (max-width: 1023px)',
    mq3: '(min-width: 1024px) and (max-width: 1279px)',
    mq4: '(min-width: 1280px)'
};


function checkMediaQuery(breakpoint) {
    return window.matchMedia(queryList[breakpoint]).matches;
}


export { queryList, checkMediaQuery };